import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      data-invalid={invalid}
      className={cn(
        'flex h-10 w-full rounded-md border bg-[var(--color-bg-primary)] px-3 py-2 text-base',
        'border-[var(--color-border-default)]',
        'placeholder:text-[var(--color-fg-tertiary)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
        'focus-visible:ring-[var(--color-brand)] focus-visible:border-[var(--color-brand)]',
        'transition-all duration-150',
        'disabled:cursor-not-allowed disabled:opacity-50',
        invalid && 'border-[var(--color-danger)] focus-visible:ring-[var(--color-danger)]',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
